import React from "react";
import { FINANCE_CALCULATOR } from "../../../../../../common-deprecated/constants";
import { BnbLabel, getBnbOptionalLabel } from "../../../utils/labels";
import { useBnbSelector } from "../../../redux/store";
import FinanceInsuranceCalculatorLink from "../../../utils/FinanceInsuranceCalculatorLink";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import Price from "../common/price/Price";
import PriceFootNote from "../common/price/PriceFootNote";
import * as Styles from "./styles/SummaryTotalPanel";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import Spacer from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Spacer";
import { getBnbPriceConfig } from "../../../utils/settings/bnbFinanceSettingUtils";
import { NavStep } from "../../../../shared-logic/utils/Navigation";

const SummaryTotalPanel = (): JSX.Element | null => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const total = useBnbSelector((state) => state.basket.total);
    const modelCode = useBnbSelector((state) => state.car?.model?.internalCode);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const isRtl = useBnbSelector((state) => isRTL(state.commonSettings));
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const showPrices = showPrice(commonSettings);
    const aemPriceConfig = getBnbPriceConfig(commonSettings, modelCode, NavStep.Summary);
    const { showFinanceInsuranceInPage, enableFinanceCompare } = bnbSettings;

    if (!showPrices || !aemPriceConfig.priceEnabled) return null;

    // show title when there is a label for it
    const showTitle =
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "financeOptionTotalCash") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "financeOptionTotalMonthly") ||
        (financeOption === "monthly" && financeInfo.productName);

    const totalLabel = financeOption === "monthly" ? "financeOptionTotalMonthly" : "financeOptionTotalCash";

    return (
        <Styles.Wrapper>
            <Styles.HeaderTitle>
                <Type.H2 m={0}>
                    <BnbLabel label="total" />
                </Type.H2>
            </Styles.HeaderTitle>

            <Styles.Panel>
                <Styles.Header>
                    <Flex.Row>
                        <Flex.Col width={1 / 2}>
                            {showTitle && (
                                <Styles.Title>
                                    {financeOption === "monthly" && financeInfo.productName ? (
                                        financeInfo.productName
                                    ) : (
                                        <BnbLabel label={totalLabel} />
                                    )}
                                </Styles.Title>
                            )}
                        </Flex.Col>
                        <Flex.Col
                            width={showTitle ? 1 / 2 : 1}
                            display="flex"
                            flexDirection="column"
                            alignItems={isRtl ? "flex-start" : "flex-end"}
                            justifyContent="flex-end"
                            textAlign="right"
                        >
                            <Styles.PriceWrapper>
                                <Price price={total} financeItemId="total" forceMonthlyDisclaimer showLoader />
                                <PriceFootNote />
                            </Styles.PriceWrapper>
                        </Flex.Col>
                    </Flex.Row>
                    {!showFinanceInsuranceInPage && !enableFinanceCompare && financeOption === "monthly" && (
                        <Flex.Row width="100%">
                            <Flex.Col display="flex" flex={1} justifyContent="flex-end">
                                <Spacer mt={2}>
                                    <FinanceInsuranceCalculatorLink
                                        type={FINANCE_CALCULATOR}
                                        customButton={(props) => (
                                            <Button.Secondary m={0} onClick={() => props.onClick()}>
                                                <Text.Button>
                                                    <BnbLabel label={props.label} />
                                                </Text.Button>
                                            </Button.Secondary>
                                        )}
                                    />
                                </Spacer>
                            </Flex.Col>
                        </Flex.Row>
                    )}
                </Styles.Header>
            </Styles.Panel>
        </Styles.Wrapper>
    );
};

export default SummaryTotalPanel;
